import Util from "ips/ac/util/Util";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import Context from "sap/ui/model/odata/v4/Context";
import { InternalOrderStatus } from "ips/ac/model/odata/generated/IpsCoreModel";
import JSONModel from "sap/ui/model/json/JSONModel";
import InternalOrderStatusDefinition
  from "ips/ac/data/internal-order-status/definition/type/InternalOrderStatusDefinition";

class InternalOrderStatusService {
  private static instance: InternalOrderStatusService;
  private loaded: boolean = false;

  private constructor() {
  }

  public static getInstance(): InternalOrderStatusService {
    return this.instance || (this.instance = new this());
  }

  public async refreshInternalOrderStatusModel(): Promise<void> {
    const component = Util.getComponent();
    const model: ODataModel = component.getModel() as ODataModel;

    const context: ODataListBinding = model.bindList("/" + InternalOrderStatusDefinition.ENTITY_SET, null, null, null, { $expand: "DestinationDetails" });
    const internalStatusContext: Context[] = await context.requestContexts(0, Infinity);
    const internalStatuses: InternalOrderStatus[] = internalStatusContext.map((context) => context.getObject());

    const vhModel: JSONModel = component.getModel("InternalOrderStatuses") as JSONModel;
    vhModel.setData(internalStatuses);

    const appModel: JSONModel = component.getAppModel();
    let oClient = appModel.getProperty("/Client");
    oClient.HasInternalInternalOrderStatuses = internalStatuses.length > 0;
    appModel.setProperty("/Client", oClient);

    this.loaded = true;
  }

  public isLoaded() {
    return this.loaded;
  }

  public async getItems(): Promise<InternalOrderStatus[]> {
    if (!this.isLoaded()) {
      await this.refreshInternalOrderStatusModel();
    }

    const model = Util.getComponent().getModel("InternalOrderStatuses") as JSONModel;
    return model.getData();
  }

  public async findItem(guid: string) {
    const items = await this.getItems();
    return items.find(item => item.Guid === guid);
  }
}

export default InternalOrderStatusService.getInstance();
